import React from 'react';
import { Button, Grid, Paper } from '@material-ui/core';
import MainContainer from '../../../components/MainContainer';
import Spacer from '../../../components/Spacer';
import MissionOrderTable from './MissionOrderTable';
import { makeStyles } from "@material-ui/core/styles";
import { useNavigate } from 'react-router';
import { headerDataMission } from '../../../data/modules/mission-header';

const useStyles = makeStyles((theme) => ({
    paper: {
      padding: theme.spacing(2),
      display: "flex",
      overflow: "auto",
      flexDirection: "column",
      elevation: 0,
    },
  }));

export default function MissionOrderList() {
    const classes = useStyles();
    const navigate = useNavigate();

    return (
        <MainContainer {...headerDataMission}>  
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <MissionOrderTable />
        </Grid>
      </Grid>
        </MainContainer>
    )
}